

function Select(){

    this.build();

}

Select.prototype.build = function(){

    $(".select_wrapper").each(function(){
        let wrapper = $(this);
        let default_option = $(this).find('.select_default_option');
        let select = $(this).find('.select_ul');

        if( $('li.current', select).length === 0 ){
            $("li", default_option).html($("li:first-of-type", select).html());
        }else{
            $("li", default_option).html($("li.current", select).html());
        }

        default_option.click(function(){
            wrapper.toggleClass("active");
        });

        $('li', select).click(function(){
            let currentele = $(this).html();
            $('li', select).removeClass('current');
            $(this).addClass('current');
            $("li", default_option).html(currentele);
            wrapper.removeClass("active");
            window.location = $("li span", default_option).data('url');
        });

    });

    $(document).click(function(event) {
        if (!$(event.target).parents('div').is(".select_wrapper")) {
            $('.select_wrapper').removeClass("active");
        }
    });

    let jobFilter = document.querySelector('.select-choice');
    if( jobFilter ){
        jobFilter.addEventListener('change', (e) => {
            window.location.href = e.target.value;
        });
    }

};